export const navItems = {
  HOME: "active",
  MENU: "",
  ACCOUNTS: "",
  CUSTOMER_CENTER: "",
  SETTINGS: "",
};
export const handleClick = (setFunction, value, navigateFunction) => {
  const newObject = {
    HOME: "",
    MENU: "",
    ACCOUNTS: "",
    CUSTOMER_CENTER: "",
    SETTINGS: "",
  };
  setFunction({ ...newObject, [value]: "active" });
  localStorage.setItem("navigationFolder", value);
  var location;
  if (value.toLowerCase() === "home") {
    location = "/" + value.toLowerCase();
  } else {
    location = value.toLowerCase();
  }

  navigateFunction(location);
};
export const handleLogout = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("navigationFolder");
  localStorage.removeItem("hotelID");
  window.location.reload();
};
